import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import NumberField from '../../../Base/NumberField';

const hatchTypes = ['', 'Standard', 'Sliding', 'Rolling', 'Folding',
    'Pontoon', 'Single Pull', 'Piggy-back', 'Stacking type'];

const producers = ['', 'Mc Gregor', 'MC Gregor-Navire', 'Kayaba',
'Nakata Mac', 'Kvaerner', 'MACOR', 'SEOHAE', 'TTS Hua Hai', 'Tsuji'];

class HoldsHatchesTop extends React.Component {
    render() {
        const holdsQuantity = this.props.holds.quantity;
        const hatchesQuantity = this.props.hatches.quantity;
        const { hatchType } = this.props.hatches;
        const { getError, changeField, changeHolds, changeHatches, confirmed, modifiedFields, underStyle, holdsHatchesProducer } = this.props;

        return (
            <div className='row'>
                <div className='col-xs-3'>
                    <NumberField
                        name='holds.quantity'
                        floatingLabelText='Holds'
                        value={holdsQuantity || ''}
                        fullWidth
                        disabled={confirmed}
                        min={0}
                        max={10}
                        onInput={(e) => {
                            e.target.value = Math.min(20, parseInt(e.target.value) ).toString().slice(0,2)
                        }}
                        onChange={(e, value) => {
                            changeHolds(value);
                        }}
                        errorText={getError('holds.quantity')}

                        underlineStyle={modifiedFields && modifiedFields.includes('holds.quantity') ? underStyle : null}
                    />
                </div>
                <div className='col-xs-3'>
                    <NumberField
                        name='hatches.quantity'
                        floatingLabelText='Hatch'
                        value={hatchesQuantity || ''}
                        disabled={confirmed}
                        fullWidth
                        min={0}
                        max={10}
                        onInput={(e) => {
                            e.target.value = Math.min(40, parseInt(e.target.value) ).toString().slice(0,2)
                        }}
                        onChange={(e, value) => {
                            changeHatches(value);
                        }}
                        errorText={getError('hatches.quantity')}

                        underlineStyle={modifiedFields && modifiedFields.includes('hatches.quantity') ? underStyle : null}
                    />
                </div>
                <div className='col-xs-3'>
                    <SelectField
                        value={hatchType}
                        disabled={confirmed}
                        onChange={(e, i, value) => {
                            changeField({
                                field: 'hatches.hatchType',
                                value,
                            });
                        }}
                        maxHeight={200}
                        name='hatches.hatchType'
                        floatingLabelText='Hatch type'
                        fullWidth
                        underlineStyle={modifiedFields && modifiedFields.includes('hatches.hatchType') ? underStyle : null}
                    >
                        {
                            hatchTypes.map((hatchType, index) => {
                                return <MenuItem
                                    key={index}
                                    value={hatchType}
                                    primaryText={hatchType}
                                />
                            })
                        }
                    </SelectField>
                </div>
                <div className='col-xs-3'>
                    <SelectField
                        value={holdsHatchesProducer}
                        disabled={confirmed}
                        onChange={(e, i, value) => {
                            changeField({
                                field: 'holdsHatchesProducer',
                                value,
                            });
                        }}
                        maxHeight={200}
                        name='holdsHatchesProducer'
                        floatingLabelText='Producer'
                        fullWidth
                        underlineStyle={modifiedFields && modifiedFields.includes('holdsHatchesProducer') ? underStyle : null}
                    >
                        {
                            producers.map(name => (
                                <MenuItem
                                    key={name}
                                    value={name}
                                    primaryText={name}
                                />
                            ))
                        }
                    </SelectField>
                </div>
            </div>
        );
    }
}

export default HoldsHatchesTop;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/HoldsHatchesTop.jsx